<template>
  <MonitorWrapper class-name="fcbr-100m">
    <el-row :gutter="40">
      <el-col v-for="item in [cwa, tvoc, smoke]" :key="item.mod" :span="item.span">
        <n-icon
          v-bind="item.icon"
          :size="144"
          :runstate="item.runstate"
          :state="item.state"
          @click.native="showSensorDataDialog(item.mod)"
        />
        <div class="cols">
          <div class="content" v-for="(cols, index) in item.list" :key="`${item.mod + index}`">
            <n-item
              v-for="(col, index) in cols"
              :key="`${col.label}_${index}`"
              v-bind="col"
              @warn-click="showFault"
            />
          </div>
        </div>
      </el-col>
    </el-row>
    <FaultPopup :visible.sync="faultVisible" :data="faults" />
    <GraphicSensorData
      :visible.sync="gsdVisible"
      :deviceType="deviceType"
      :hisData="hisData"
      :first="first"
      :sn="sn"
    />
  </MonitorWrapper>
</template>

<script>
import monitorMixin from '@/mixins/monitorMixin';

import NIcon from '@/components/musicbox/icon/mod-state.vue';
import NItem from './components/item.vue';
import FaultPopup from './components/fault-popup.vue';
import GraphicSensorData from '@/components/graphicSensorData/index.vue';
import { symmetry, colsSort } from '@/utils/sort';

export default {
  components: {
    GraphicSensorData,
    FaultPopup,
    NItem,
    NIcon
  },
  mixins: [monitorMixin],
  data() {
    return {
      runstate: 0,
      faultVisible: false,
      gsdVisible: false,
      first: '',
      faults: [],
      hisData: null,
      cwa: {
        mod: 'cwaMod',
        span: 5,
        col: 1,
        runstate: 0,
        state: 0,
        list: [],
        icon: {
          icon: 'chemical-weapon',
          title: '化学战剂'
        }
      },
      tvoc: {
        mod: 'tvocMod',
        span: 14,
        col: 3,
        runstate: 0,
        state: 0,
        list: [],
        icon: {
          icon: 'dupin',
          title: '有毒有害气体'
        }
      },
      smoke: {
        mod: 'smokeMod',
        span: 5,
        col: 1,
        runstate: 0,
        state: 0,
        list: [],
        icon: {
          icon: 'leaf',
          title: '空气质量检测'
        }
      }
    };
  },
  methods: {
    showSensorDataDialog(mod) {
      this.gsdVisible = true;
      this.first = mod;
    },
    showFault() {
      this.faultVisible = !this.faultVisible;
    },
    /** @type {(src: [], col: number) => [][]} */
    multiColHanlder(src, col) {
      if (!src.length) return [];
      const over = src.length % col;
      const cols = colsSort(src.length, col);
      const res = cols.map(rows => rows.map(i => src[i]));
      if (over) {
        let overArr = src.slice(-over);
        const arr = symmetry(src.length, col);
        arr.forEach((e, i) => e && res[i].push(overArr.shift()));
      }
      return res;
    },
    upFault(res) {
      if (!Array.isArray(res.faults)) return;
      this.faults.splice(0, Infinity, ...res.faults);
    },
    updateHisData(res) {
      if (!res || !res.data || !Array.isArray(res.data.deviceDatas)) return;
      this.hisData = res.data.deviceDatas;
      this.updateData(res.data.deviceData);
    },
    smokeHandler(datas) {
      const target = datas.find(e => e.code === 'SMOKE');
      if (!target) return;
      target.unit = '';
      target.value = target.state > 0 ? '警' : '正常';
    },
    updateData(res) {
      try {
        const { mods, runstate } = res;
        const { cwa, tvoc, smoke } = this;
        // 设备运行状态
        this.runstate = runstate;
        const alarmContent = mods[smoke.mod].alarmContent;
        // 烟气报警
        smoke.alarmMsg = alarmContent === '无' ? '' : alarmContent;
        // 更新模块状态
        [cwa, tvoc, smoke].forEach(e => {
          e.state = mods[e.mod].state;
          e.runstate = mods[e.mod].runstate;
        });
        // 更新传感器信息
        [cwa, tvoc, smoke].forEach(e => {
          let sensors = mods[e.mod].sensors;
          if (!sensors) return;
          const res = sensors.map(e => ({
            code: e.code,
            value: e.value,
            state: e.alarmState,
            unit: e.unitName,
            label: e.name,
            faultState: e.faultState,
            alarmType: e.alarmTypeLevels && e.alarmTypeLevels.join(' ')
          }));
          this.smokeHandler(res);
          e.list.splice(0, Infinity, ...this.multiColHanlder(res, e.col));
        });
        // 更新故障信息
        this.upFault(res);
      } catch (e) {
        console.log('更新FCBR100M设备监控状态失败: ', e);
      }
    }
  }
};
</script>

<style lang="scss">
.fcbr-100m {
  display: block;
  height: 100%;
  .el-row {
    height: 100%;
    .el-col {
      height: 100%;
      display: flex;
      flex-direction: column;
      align-items: center;
    }
  }
  .cols {
    display: flex;
    width: 100%;
    height: 100%;
  }
  .content {
    width: 100%;
    flex: 1;
    display: flex;
    flex-direction: column;
    background: #172128;
    border: 1px solid #00a7b3;
    .list-item:not(:last-of-type) {
      border-bottom: 1px solid #00a7b3;
    }
    .list-item:nth-of-type(even) {
      background: rgba(13, 23, 36, 0.7);
    }
  }
  .text-content {
    width: 100%;
    flex: 1;
    background: rgba(72, 156, 214, 0.1);
    border: 1px solid #00a7b3;
    display: flex;
    align-items: center;
    justify-content: center;
    span {
      writing-mode: vertical-lr;
      letter-spacing: 10px;
      font-size: 22px;
    }
  }
}
</style>
